import request from "@/service";

//班级列表
export function getStudyClassList(params) {
  return request({
    url: `/study/class/info/page`,
    method: "get",
    params
  });
}

/* 班级新增 */
export function saveStudyClass(params) {
  return request({
    url: `/study/class/info/save`,
    method: "post",
    data: params
  });
}

/* 班级详情 */
export function getStudyClassInfo(uuid) {
  return request({
    url: `/study/class/info/info/${uuid}`,
    method: "get"
  });
}

/* 班级修改 */
export function updateStudyClass(params) {
  return request({
    url: `/study/class/info/update`,
    method: "put",
    data: params
  });
}

/* 班级删除 */
export function deleteClass(params) {
  return request({
    url: `/study/class/info/delete`,
    method: "delete",
    data: params
  });
}

/* 发布/取消发布 */
export function publishClass(params) {
  return request({
    url: `/study/class/info/publish`,
    method: "put",
    data: params
  });
}

/* 报名审核人列表 */
export function getEnrollAuditorList(data) {
  return request({
    url: `/user/sys/user/getEnrollAuditorList`,
    method: "post",
    data
  });
}

/* 已发布班级名称列表 */
export function getPublishedClassList(params) {
  return request({
    url: `/study/class/info/namePage`,
    method: "get",
    params
  });
}

/*  首页配置-资源-班级选择 */
export function getSelectClassList(params) {
  return request({
    url: `/study/class/info/selectPage`,
    method: "get",
    params
  });
}

/* 班级学员树 */
export function getClassStudentTree(params) {
  return request({
    url: `/study/class/enroll/findClassStudentTree`,
    method: "get",
    params
  });
}

/* 班级概况，班级分类统计-zhangtb */
export function findClassStatistics(params) {
  return request({
    url: `/study/class/statistic/findClassStatistics`,
    method: "get",
    params
  });
}

export function findClassStatisticsNew(params) {
  return request({
    url: `/study/class/statistic/findClassStatistics/v2`,
    method: "get",
    params
  });
}

// 线上班级开班情况-clc
export function getOnlineClassStattistics(params) {
  return request({
    url: `/study/class/statistic/onlineClassStatistics`,
    method: "post",
    data: params
  });
}

export function exportOnlineClassStatis(data) {
  return request({
    url: `/study/class/statistic/exportOnline`,
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data
  });
}


/* 班级明细统计-zhangtb */
export function findClassDetailStatistics(params) {
  return request({
    url: `/study/class/statistic/findClassDetailStatistics`,
    method: "post",
    data: params
  });
}

/* 班级作业统计-zhangtb */
export function findClassWorkStatistics(classId) {
  return request({
    url: `/study/class/statistic/findClassWorkStatistics/${classId}`,
    method: "get"
  });
}

/* 班级考试统计-zhangtb */
export function findExamStatistics(classId) {
  return request({
    url: `/study/class/statistic/findExamStatistics/${classId}`,
    method: "get"
  });
}

/* 班级类型列表（线下班级二级列表+线上班级类型）-jcc */
export function tranTypeList() {
  return request({
    url: `/sys/sys/param/list/tranTypeList`,
    method: "get"
  });
}

// 获取班级列表
export function getClassByName(params) {
  return request({
    url: `/resource/class/info/nameList`,
    method: "get",
    params
  });
}

// 获取课程表
export function getCourseSchedule(params) {
  return request({
    url: `/study/class/course/courseSchedule`,
    method: "get",
    params
  });
}
// 训中数据分页列表
export function Training(params) {
  return request({
    url: `/study/class/info/trainingClassPage`,
    method: "post",
    data: params
  });
}

// 查询入学通知书
export function pageAdmissionNotice(params) {
  return request({
    url: `/study/class/fileLibrary/pageAdmissionNotice`,
    method: "get",
    params
  });
}

// 查询入学通知书管理分页列表
export function pageAdmissionNoticeManage(params) {
  return request({
    url: `/study/class/fileLibrary/classManagePage`,
    method: "get",
    params
  });
}

// 获取日程安排
export function getCourseList(params) {
  return request({
    url: `/study/class/course/getList`,
    method: "get",
    params
  });
}

/* 导入日程安排 */
export function importCourse(params) {
  return request({
    url: `/study/class/course/importcourse`,
    method: "post",
    headers: {
      "Content-Type":
        "multipart/foresource-data; boundary=----WebKitForesourceBoundaryyJzVStTyqSc9B1Ut"
    },
    data: params
  });
}

// 上级调训班级列表
export function getSuperiorTrainClass(params) {
  return request({
    url: `/study/class/info/superiorTrainClass`,
    method: "get",
    params
  });
}

// 学员报到-管理分页列表
export function getPageEnrollClock(params) {
  return request({
    url: `/study/class/enroll/pageEnrollClockStatus`,
    method: "get",
    params
  });
}

// 学员报到-小班列表
export function getChildClassList(params) {
  return request({
    url: `/study/class/info/childClassList`,
    method: "get",
    params
  });
}

/* 学员报到-手动报到 */
export function updateClockStatus(params) {
  return request({
    url: `/study/class/enroll/updateClockStatus`,
    method: "post",
    data: params
  });
}

/* 学员报到-导出学员报到列表 */
export function exportEnrollClockStatus(params) {
  return request({
    url: `/study/class/enroll/exportEnrollClockStatus`,
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data: params
  });
}

/* 日程安排-新增 */
export function saveCourseClass(params) {
  return request({
    url: `/study/class/course/save`,
    method: "post",
    data: params
  });
}

/* 日程安排-修改 */
export function updateCourseClass(params) {
  return request({
    url: `/study/class/course/update`,
    method: "post",
    data: params
  });
}

/* 日程安排-详情 */
export function getCourseClassInfo(uuid) {
  return request({
    url: `/study/class/course/info/${uuid}`,
    method: "get"
  });
}

/* 日程安排-判断是否有座位号 */
export function hasSeat(classId) {
  return request({
    url: `/study/class/course/hasSeat/${classId}`,
    method: "get"
  });
}

/* 日程安排-删除 */
export function deleteCourseClass(params) {
  return request({
    url: `/study/class/course/delete`,
    method: "post",
    data: params
  });
}

/* 日程安排-座位号管理 */
export function classUserSeatPage(params) {
  return request({
    url: `/study/classUserSeat/page`,
    method: "get",
    params
  });
}

// 日程安排-地点列表
export function classRoomPage(params) {
  return request({
    url: `/study/classRoom/page`,
    method: "get",
    params
  });
}
// 日程安排-教室组列表
export function classRoomGroupPage(params) {
  return request({
    url: `/study/classRoomGroup/getList`,
    method: "get",
    params
  });
}

/* 日程安排-导出 */
export function exportClassCourse(params) {
  return request({
    url: `/study/class/course/exportClassCourse`,
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    params
  });
}

/* 日程安排-座位号-修改 */
export function updateClassUserSeat(params) {
  return request({
    url: `/study/classUserSeat/update`,
    method: "post",
    data: params
  });
}

/* 导入日程安排 */
export function importUserSeat(params) {
  return request({
    url: `/study/classUserSeat/importUserSeat`,
    method: "post",
    headers: {
      "Content-Type":
        "multipart/foresource-data; boundary=----WebKitForesourceBoundaryyJzVStTyqSc9B1Ut"
    },
    data: params
  });
}

/* 新增中组部选调班-延期wangchao */
export function saveClassOperationLog(data) {
  return request({
    url: `/study/classOperationLog/save`,
    method: "post",
    data
  });
}

// 班级延期列表-wangchao
export function classOperationLogList(params) {
  return request({
    url: `/study/classOperationLog/list`,
    method: "get",
    params
  });
}

/**
 * 消息群发中组部选调班查询
 * @param {*} params 
 * @returns 
 */
 export function getTransferClassPage(params) {
  return request({
    url: "/study/class/info/transferClassPage",
    method: "get",
    params
  });
}

/* 分组管理-修改房间号 */
export function updateRoomNumber(params) {
  return request({
    url: `/study/class/enroll/update`,
    method: "post",
    data: params
  });
}

/* 主办单位-下拉列表 */
export function getClassDropList(params) {
  return request({
    url: `/study/classOrganizer/classDropList`,
    method: "get",
    params
  });
}

// 预览通知书
export function previewNotice(params) {
  return request({
    url: `/study/class/fileLibrary/previewNotice`,
    method: "post",
    data: params
  });
}


// 导入入学通知书模板并发送
export function importAdmissionNoticeToSend(params) {
  return request({
    url: `/study/class/fileLibrary/sendNotice`,
    method: "post",
    headers: {
      "Content-Type":
        "multipart/foresource-data; boundary=----WebKitForesourceBoundaryyJzVStTyqSc9B1Ut"
    },
    data: params
  });
}

export function getOnlineClass(params) {
  return request({
    url: `/study/class/info/cdnClassPage`,
    method: "get",
    params
  });
}

// 智能分组设置-详情
export function groupLineInfo(params) {
  return request({
    url: `/study/class/group/groupLineInfo`,
    method: "get",
    params
  });
}

// 智能分组设置-保存
export function groupLineInfoSave(data) {
  return request({
    url: `/study/class/group/groupLineInfoSave`,
    method: "post",
    data
  });
}






